// src/utils/safeRender.js

/**
 * Безопасный рендеринг значений в React
 * Предотвращает ошибку "Objects are not valid as a React child"
 */
export function safeRender(value, fallback = '') {
  if (value === null || value === undefined) {
    return fallback;
  }
  
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  
  if (typeof value === 'object') {
    // Если это объект, пытаемся извлечь текстовое представление
    if (value.name) return String(value.name);
    if (value.name_ru) return String(value.name_ru);
    if (value.name_en) return String(value.name_en);
    if (value.title) return String(value.title);
    if (value.title_ru) return String(value.title_ru);
    if (value.title_en) return String(value.title_en);
    if (value.slug) return String(value.slug);
    
    // Если ничего не найдено, возвращаем fallback
    console.warn('Attempted to render object as text:', value);
    return fallback;
  }
  
  return String(value);
}

/**
 * Безопасное извлечение имени района
 */
export function safeRegionName(region, fallback = '') {
  if (!region) return fallback;
  if (typeof region === 'string') return region;
  if (typeof region === 'object') {
    return region.name || region.name_ru || region.name_en || region.slug || fallback;
  }
  return String(region);
}

/**
 * Безопасное извлечение данных района для ссылок
 */
export function safeDistrictData(district, fallback = null) {
  if (!district) return fallback;
  
  // Если district - строка, используем её как название
  if (typeof district === 'string') {
    return {
      name: district,
      slug: 'unknown'
    };
  }
  
  // Если district - объект, извлекаем данные
  if (typeof district === 'object') {
    return {
      name: district.name || district.name_ru || district.name_en || 'Район',
      slug: district.slug || 'unknown'
    };
  }
  
  return fallback;
}